import React from 'react';

class Globals extends React.Component {

    static userInfo = {
        fName: "",
        lName: "",
        isLoggedIn: false,
        userType: "",
        userMenu: [],
        email: "",
        users_Id: 0,
        companies_id: 0,
        company_name: "",
        suppressEmails: false,
        suppressAllEmails: false,
        accessToProjects: true,
        accessToSecureDocuments: true,
        accessToBackups: true,
        bearer: ""
    };

    static tempProjID = 0;
    
    static projectData = {};

    static customers = [];

    static defaultLoadingMessage = "Use the search bar above";
    static customersLoadingMessage = "Use the search bar above";

    static findByRoute = (o, route) => {
        if (o.route === route) {
            return o;
        }
        var result, p;
        for (p in o) {
            if (o.hasOwnProperty(p) && typeof o[p] === 'object') {
                result = Globals.findByRoute(o[p], route);
                if (result) {
                    return result;
                }
            }
        }
        return result;
    }

}

export default Globals;
